document.addEventListener('DOMContentLoaded', function () {
  const gallery = document.querySelector('.lesson-entry__gallery');
  const prevBtn = document.querySelector('.lesson-gallery-nav--prev');
  const nextBtn = document.querySelector('.lesson-gallery-nav--next');

  if (!gallery || !prevBtn || !nextBtn) return;

  function scrollToImage(direction) {
    const images = Array.from(gallery.querySelectorAll('.lesson-entry__image'));
    if (images.length === 0) return;

    const galleryCenter = gallery.scrollLeft + gallery.clientWidth / 2;

    // Find the image closest to the center
    let closestIndex = 0;
    let minDiff = Infinity;

    images.forEach((img, index) => {
      const imgCenter = img.offsetLeft + img.offsetWidth / 2;
      const diff = Math.abs(galleryCenter - imgCenter);
      if (diff < minDiff) {
        minDiff = diff;
        closestIndex = index;
      }
    });

    // Determine target index
    let targetIndex = direction === 'next' ? closestIndex + 1 : closestIndex - 1;

    // Clamp index
    if (targetIndex < 0) targetIndex = 0;
    if (targetIndex >= images.length) targetIndex = images.length - 1;

    // Calculate scroll position to center the target
    const targetImg = images[targetIndex];
    const scrollPos = targetImg.offsetLeft + targetImg.offsetWidth / 2 - gallery.clientWidth / 2;

    gallery.scrollTo({
      left: scrollPos,
      behavior: 'smooth'
    });
  }

  prevBtn.addEventListener('click', () => scrollToImage('prev'));
  nextBtn.addEventListener('click', () => scrollToImage('next'));
});
